module.exports = __webpack_public_path__ + "static/media/person5.3502596e.png";